import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  signal
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilityService } from '@cpd-app/core-module/services';

@Component({
  templateUrl: './not-enough-credit-dialog.component.html',
  styleUrls: ['./not-enough-credit-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotEnoughCreditDialogComponent implements OnInit {
  protected readonly resetTime$ = signal<string>('');

  public constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: { resetTime: number | string },
    private dialogRef: MatDialogRef<NotEnoughCreditDialogComponent>
  ) {}

  public ngOnInit(): void {
    this.resetTime$.set(
      UtilityService.getTimeUntilResetString(this.data.resetTime as string)
    );
  }

  protected close(): void {
    this.dialogRef.close();
  }
}
